import {combineReducers, Reducer} from '@reduxjs/toolkit'

import {routerReducer} from '@web/slices/router'

import {CheckoutRootState as RootState} from '../../interfaces'
import abTest from '../../slices/abTest'
import account from '../../slices/account'
import additionalOption from '../../slices/additionalOption'
import affiliatePoint from '../../slices/affiliatePoint'
import agreement from '../../slices/agreement'
import banner from '../../slices/banner'
import branch from '../../slices/branch'
import card from '../../slices/card'
import cashReceipt from '../../slices/cashReceipt'
import chargePoint from '../../slices/chargePoint'
import common from '../../slices/common'
import deliveryGroup from '../../slices/deliveryGroup'
import deliveryInfo from '../../slices/deliveryInfo'
import deliveryManager from '../../slices/deliveryManager'
import error from '../../slices/error'
import gift from '../../slices/gift'
import merchants from '../../slices/merchants'
import mobile from '../../slices/mobile'
import moneyToken from '../../slices/moneyToken'
import orderProcessor from '../../slices/orderProcessor'
import orderSheetCoupon from '../../slices/orderSheetCoupon'
import orderSheetProducts from '../../slices/orderSheetProducts'
import orderTotal from '../../slices/orderTotal'
import payLater from '../../slices/payLater'
import paymentMethod from '../../slices/paymentMethod'
import payNext from '../../slices/payNext'
import personalCustomsClearance from '../../slices/personalCustomsClearance'
import pickup from '../../slices/pickup'
import pointPayment from '../../slices/pointPayment'
import purchaser from '../../slices/purchaser'
import receiverInfo from '../../slices/receiverInfo'
import reward from '../../slices/reward'
import rewardPoint from '../../slices/rewardPoint'
import voucher from '../../slices/voucher'
import waiting from '../../slices/waiting'

const createRootReducer = (): Reducer<RootState> =>
    combineReducers({
        abTest,
        account,
        affiliatePoint,
        agreement,
        additionalOption,
        banner,
        branch,
        card,
        cashReceipt,
        chargePoint,
        common,
        deliveryGroup,
        deliveryInfo,
        deliveryManager,
        error,
        gift,
        merchants,
        mobile,
        moneyToken,
        orderProcessor,
        orderSheetCoupon,
        orderSheetProducts,
        orderTotal,
        payLater,
        paymentMethod,
        payNext,
        personalCustomsClearance,
        pickup,
        pointPayment,
        purchaser,
        receiverInfo,
        reward,
        rewardPoint,
        router: routerReducer,
        voucher,
        waiting,
    })

export default createRootReducer
